/* eslint-disable no-nested-ternary */
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCompanyEnrollmentInfo } from '../../../common/useCompanyEnrollmentInfo';
import { useSolutionOrg } from '../../../config/useSolutionOrg';
import { EverProEdgePublicSolutionOrgName, ServiceFusionSolutionOrgName, ServiceNationSolutionOrgName } from '../../../common/constants';
import AuthenticatedRoute from '../../AuthenticatedRoute';
import { OnboardHDHomeWeb } from './OnboardHDHomeWeb';
import {
  isUserInitiatedHomeDepotEnrollment,
  resolveHomeDepotSetupReturnPath,
} from '../../../common/homeDepotEnrollmentIntent';
import { getDashboardEntryRoute } from '../../../common/dashboardEntryRoute';
import { HOME_ROUTE } from '../../../routes/namedRoutes';

function OnboardHDHomeWebWrapperInner() {
  const { solutionOrgName } = useSolutionOrg();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    returnPath: returnPathFromState,
  } = location.state || {};

  // Get params from URL query (HDX/BEHR flow) or location.state (HD direct flow)
  const searchParams = new URLSearchParams(location.search);
  const returnPath = searchParams.get('returnPath') || returnPathFromState || undefined;
  const userInitiatedHdEnrollment = isUserInitiatedHomeDepotEnrollment({
    state: location.state,
    search: location.search,
    redirectPath: returnPath,
  });
  const isServiceNationNative = solutionOrgName === ServiceNationSolutionOrgName;
  const isServiceFusion = solutionOrgName === ServiceFusionSolutionOrgName;
  const shouldRedirectAwayFromHomeDepotSetup =
    (solutionOrgName === EverProEdgePublicSolutionOrgName ||
      isServiceNationNative ||
      isServiceFusion) &&
    !userInitiatedHdEnrollment;
  // Service Nation native and Service Fusion members always land on Home. Everyone else honors
  // an explicit returnPath (e.g. a campaign link carrying a promo code) and only falls back to
  // Home when no destination was supplied.
  const redirectPath = (isServiceNationNative || isServiceFusion || !returnPath) ?
    HOME_ROUTE :
    resolveHomeDepotSetupReturnPath({
      redirectPath: returnPath,
      fallbackPath: getDashboardEntryRoute(solutionOrgName),
    });

  // check company enrollment status
  useCompanyEnrollmentInfo({
    calledFromOnboardingComponent: false,
    enableOnboardingFlowTestRedirect: true,
    redirectPath: returnPath,
  });

  useEffect(() => {
    if (shouldRedirectAwayFromHomeDepotSetup) {
      navigate(redirectPath, { replace: true });
    }
  }, [navigate, redirectPath, shouldRedirectAwayFromHomeDepotSetup]);

  // Don't render Home Depot enrollment page for EverPro Edge Public, Service Nation,
  // or Service Fusion UNLESS the user explicitly initiated HD enrollment (e.g., from HDX or BEHR).
  if (shouldRedirectAwayFromHomeDepotSetup) {
    return null;
  }

  return <OnboardHDHomeWeb />;
}

export function OnboardHDHomeWebWrapper() {
  return (
    <AuthenticatedRoute>
      <OnboardHDHomeWebWrapperInner />
    </AuthenticatedRoute>
  );
}
